import { CompanyType } from './company-type';

export class Company {
  id: string;
  companyId: number;
  nameEn: string;
  symbol: string;
  companyType: CompanyType;
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/company.ts